/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetBillingDetails200ResponseCard } from './GetBillingDetails200ResponseCard';
import {
    GetBillingDetails200ResponseCardFromJSON,
    GetBillingDetails200ResponseCardFromJSONTyped,
    GetBillingDetails200ResponseCardToJSON,
    GetBillingDetails200ResponseCardToJSONTyped,
} from './GetBillingDetails200ResponseCard';
import type { GetBillingDetails200ResponseIban } from './GetBillingDetails200ResponseIban';
import {
    GetBillingDetails200ResponseIbanFromJSON,
    GetBillingDetails200ResponseIbanFromJSONTyped,
    GetBillingDetails200ResponseIbanToJSON,
    GetBillingDetails200ResponseIbanToJSONTyped,
} from './GetBillingDetails200ResponseIban';
import type { GetBillingDetails200ResponseTax } from './GetBillingDetails200ResponseTax';
import {
    GetBillingDetails200ResponseTaxFromJSON,
    GetBillingDetails200ResponseTaxFromJSONTyped,
    GetBillingDetails200ResponseTaxToJSON,
    GetBillingDetails200ResponseTaxToJSONTyped,
} from './GetBillingDetails200ResponseTax';

/**
 * 
 * @export
 * @interface GetBillingDetails200Response
 */
export interface GetBillingDetails200Response {
    /**
     * 
     * @type {string}
     * @memberof GetBillingDetails200Response
     */
    fiscalName: string;
    /**
     * 
     * @type {string}
     * @memberof GetBillingDetails200Response
     */
    taxId: string;
    /**
     * 
     * @type {string}
     * @memberof GetBillingDetails200Response
     */
    fiscalAddress: string;
    /**
     * 
     * @type {string}
     * @memberof GetBillingDetails200Response
     */
    email: string;
    /**
     * 
     * @type {GetBillingDetails200ResponseTax}
     * @memberof GetBillingDetails200Response
     */
    tax: GetBillingDetails200ResponseTax;
    /**
     * 
     * @type {boolean}
     * @memberof GetBillingDetails200Response
     */
    hasPaymentMethod: boolean;
    /**
     * 
     * @type {GetBillingDetails200ResponseCard}
     * @memberof GetBillingDetails200Response
     */
    card?: GetBillingDetails200ResponseCard;
    /**
     * 
     * @type {GetBillingDetails200ResponseIban}
     * @memberof GetBillingDetails200Response
     */
    iban?: GetBillingDetails200ResponseIban;
}

/**
 * Check if a given object implements the GetBillingDetails200Response interface.
 */
export function instanceOfGetBillingDetails200Response(value: object): value is GetBillingDetails200Response {
    if (!('fiscalName' in value) || value['fiscalName'] === undefined) return false;
    if (!('taxId' in value) || value['taxId'] === undefined) return false;
    if (!('fiscalAddress' in value) || value['fiscalAddress'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('tax' in value) || value['tax'] === undefined) return false;
    if (!('hasPaymentMethod' in value) || value['hasPaymentMethod'] === undefined) return false;
    return true;
}

export function GetBillingDetails200ResponseFromJSON(json: any): GetBillingDetails200Response {
    return GetBillingDetails200ResponseFromJSONTyped(json, false);
}

export function GetBillingDetails200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBillingDetails200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'fiscalName': json['fiscalName'],
        'taxId': json['taxId'],
        'fiscalAddress': json['fiscalAddress'],
        'email': json['email'],
        'tax': GetBillingDetails200ResponseTaxFromJSON(json['tax']),
        'hasPaymentMethod': json['hasPaymentMethod'],
        'card': json['card'] == null ? undefined : GetBillingDetails200ResponseCardFromJSON(json['card']),
        'iban': json['iban'] == null ? undefined : GetBillingDetails200ResponseIbanFromJSON(json['iban']),
    };
}

export function GetBillingDetails200ResponseToJSON(json: any): GetBillingDetails200Response {
    return GetBillingDetails200ResponseToJSONTyped(json, false);
}

export function GetBillingDetails200ResponseToJSONTyped(value?: GetBillingDetails200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fiscalName': value['fiscalName'],
        'taxId': value['taxId'],
        'fiscalAddress': value['fiscalAddress'],
        'email': value['email'],
        'tax': GetBillingDetails200ResponseTaxToJSON(value['tax']),
        'hasPaymentMethod': value['hasPaymentMethod'],
        'card': GetBillingDetails200ResponseCardToJSON(value['card']),
        'iban': GetBillingDetails200ResponseIbanToJSON(value['iban']),
    };
}

